import { Grid, IconButton, Tooltip } from '@mui/material'
import { useEffect, useState } from 'react'
import { MdAdd, MdArrowBack } from 'react-icons/md'
import Programa from '../../../components/Programa/Programa'
import EdicaoDispensacao from './EdicaoDispensacao'
import PrimeTable from '../../../components/PrimeTable'

export const STATUS_MAP = {
  0: { label: 'Pendente', color: '#1976d2', background: '#e3f2fd' },
  1: { label: 'Parcial', color: '#ff9800', background: '#fff3e0' },
  2: { label: 'Finalizado', color: '#2e7d32', background: '#e8f5e9' },
  9: { label: 'Cancelado', color: '#9e9e9e', background: '#ffebee' },
}

export function StatusChip({ status }) {
  const info = STATUS_MAP[status]

  if (!info) return status // fallback

  return (
    <span
      style={{
        display: 'inline-block',
        padding: '4px 10px',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: 600,
        width: '100%',
        color: info.color,
        backgroundColor: info.background,
        textAlign: 'center',
      }}
    >
      {info.label}
    </span>
  )
}

const Dispensacao = () => {
  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [dados, setDados] = useState(null)
  const [reloadTable, setReloadTable] = useState(null)

  const voltar = () => {
    setTela('lista')
    setDados([])
    setReloadTable((v) => !v)
  }

  const handleClick = (linha) => {
    setDados(linha)
    setTela('opcoes')
  }

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar">
            <IconButton onClick={() => setTela('opcoes')}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tela])

  return (
    <Programa codigo="CtrlDispensacao" ferramentas={ferramentas}>
      {tela === 'opcoes' ? (
        <EdicaoDispensacao
          {...{
            dados,
            voltar,
            setTela,
            setReloadTablePrincipal: setReloadTable,
          }}
        />
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid item xs={12}>
              <PrimeTable
                action="lista"
                codigo="CtrlDispensacao"
                refresh={reloadTable}
                collumnsDateHour={[3]}
                head={[
                  'Solicitante',
                  'Paciente',
                  'Centro de Custo',
                  'Inclusão',
                  'Situação',
                  'Dispensado',
                ]}
                line={(item) => [
                  item[1]?.[1],
                  item[2]?.[1],
                  item[3]?.[1],
                  item[6],
                  item[5] ? <StatusChip status={item[5]} /> : '',
                  `${item[8]} / ${item[9]}`,
                ]}
                onRowSelect={handleClick}
              />
            </Grid>
          </Grid>
        </Grid>
      )}
    </Programa>
  )
}

export default Dispensacao
